import jQuery from 'jquery';
import _ from 'lodash';

let selections = [];
let parentElm;
let selectionRange;

const removeAllSelections = () => {
  _.forEach(selections, (selectDiv) => {
    selectDiv.remove();
  });

  selections = [];
};

const getSelectionBounds = (rect, parentOffset) => {
  return {
    top: rect.top - parentOffset.top + 'px',
    left: rect.left - parentOffset.left + 'px',
    width: rect.width + 'px',
    height: rect.height + 'px',
  };
};

const setElementAndRange = (elm, newRange) => {
  parentElm = elm;
  selectionRange = newRange;
};

const imitateSelection = () => {
  if ( ! selectionRange) { return; }

  removeAllSelections();

  const parentOffset = jQuery(parentElm).offset();
  const clientRects = selectionRange.getClientRects();

  selections = _.map(clientRects, (rect) => {
    return jQuery('<div class="text-edit-highlight">')
      .css(getSelectionBounds(rect, parentOffset))
      .appendTo(parentElm);
  });
};

export default {
  removeAllSelections,
  getSelectionBounds,
  imitateSelection,
  setElementAndRange
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/utils/selection-highlight-imitator.js